import { toYmdLocal } from "./formatDate";

/**
 * Fecha mínima permitida para crear/editar servicios (YYYY-MM-DD).
 * Permite back-dating controlado: si "hoy" es posterior a esta fecha,
 * se podrán seguir creando servicios con fecha igual o posterior a la mínima.
 */
export const MIN_SERVICE_DATE_YMD = "2026-05-16";

/**
 * Devuelve la fecha mínima efectiva permitida (YMD) para el date picker
 * y validaciones: el menor entre "hoy" y MIN_SERVICE_DATE_YMD.
 */
export function getMinServiceDateYmd(): string {
  const today = toYmdLocal();
  return today < MIN_SERVICE_DATE_YMD ? today : MIN_SERVICE_DATE_YMD;
}

/**
 * Indica si la fecha/hora del servicio (interpretada en hora local del navegador)
 * es estrictamente anterior al instante mínimo permitido. El instante mínimo es
 * el menor entre "ahora" y MIN_SERVICE_DATE_YMD a las 00:00:00, de modo que
 * fechas desde MIN_SERVICE_DATE_YMD en adelante siempre sean aceptadas.
 */
export function isServiceDateTimeInPast(
  dateYmd: string | null | undefined,
  timeRaw: string | null | undefined
): boolean {
  const date = String(dateYmd ?? "").trim();
  const time = String(timeRaw ?? "").trim();
  if (!date || !time) return false;

  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!m) return false;

  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);

  const tp = time.slice(0, 8).split(":");
  const hh = Number(tp[0] ?? 0);
  const mm = Number(tp[1] ?? 0);
  const ss = Number(tp[2] ?? 0);

  const sched = new Date(y, mo, d, hh, mm, ss);
  if (Number.isNaN(sched.getTime())) return false;

  const mMin = /^(\d{4})-(\d{2})-(\d{2})$/.exec(MIN_SERVICE_DATE_YMD);
  const minAllowed = mMin
    ? new Date(Number(mMin[1]), Number(mMin[2]) - 1, Number(mMin[3]), 0, 0, 0).getTime()
    : Date.now();

  const threshold = Math.min(Date.now(), minAllowed);

  return sched.getTime() < threshold;
}
